import { removed } from '@mailobj-browser/front/js/tree/tree.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import { event } from '@mailobj-browser/front/js/events/listeners/emitters.js'

const onLoad = event('load', { passive })
const resolvers = new WeakMap()

export const load = async (iframe, designMode = false) => {
  const { contentWindow } = iframe

  if (!contentWindow) {
    if (!resolvers.has(iframe)) {
      resolvers.set(iframe, resolvable())

      queueMicrotask(async () => {
        if (await onLoad(iframe, removed(iframe))) {
          const [, { resolve }] = resolvers.get(iframe)

          resolve()
        }
      })
    }

    await resolvers.get(iframe).get(0)
    resolvers.delete(iframe)
  }

  if (designMode) {
    const { contentDocument } = iframe

    contentDocument.designMode = 'on'
  }

  return iframe
}
